
import { Navigate, Outlet} from "react-router-dom";


export const PrivateRoute = () => {
    const isAuthenticate = localStorage.getItem("logged_in_User");
  if (isAuthenticate !== "true") {
   return <Navigate to={"/login"} />
  }
else{
return <Outlet/>
}

};
